import { render, staticRenderFns } from "./FazendaList.vue?vue&type=template&id=3bd0e518"
import script from "./FazendaList.vue?vue&type=script&lang=js"
export * from "./FazendaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports